module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-SemiBold.f36493c.woff";